module.exports = __webpack_public_path__ + "img/221121-bimistock------@1x.ebcc2c06.png";